<template>
  <AnnotationList
    :can-create="!!openCreateAnnotation"
    @create-annotation="openCreateAnnotation?.()"
  />
</template>

<script setup lang="ts">
import AnnotationList from "@/components/Core/Annotations/AnnotationList.vue";
import { useAnnotationCreateOpener } from "@/composables/useAnnotationCreateShortcut";

const openCreateAnnotation = useAnnotationCreateOpener();
</script>
